
// import * as usersAPI from './users-api'


// export async function signUp(userData) {
//     const token = await usersAPI.signUp(userData);
//     localStorage.setItem("token", token)
//     return getUser();
// }

// export async function login(credentials) {
//     // Delegate the AJAX request to the users-api.js
//     // module.
//     const token = await usersAPI.login(credentials);
//     localStorage.setItem('token', token);
//     return getUser();
//   }

// export function logOut() {
//     localStorage.removeItem("token")
// }

// export function getToken() {
//     // getItem returns null if there's no string
//     const token = localStorage.getItem('token');
//     if (!token) return null;
//     // Obtain the payload of the token
//     const payload = JSON.parse(atob(token.split('.')[1]));
//     // A JWT's exp is expressed in seconds, not milliseconds, so convert
//     if (payload.exp < Date.now() / 1000) {
//       // Token has expired - remove it from localStorage
//       localStorage.removeItem('token');
//       return null;
//     }
//     return token;
//   }
  
//   export function getUser() {
//     const token = getToken();
//     // If there's a token, return the user in the payload, otherwise return null
//     return token ? JSON.parse(atob(token.split('.')[1])).user : null;
//   }

//   export function checkToken() {
//     return usersAPI.checkToken()
//         .then(dateStr => new Date(dateStr))
//   }



// updated code below 10.5.25 allows this to run without only doing incognito mode!

// users-service.js
import * as usersAPI from './users-api';

// --- helpers ---
function toBase64(b64url) {
  // JWT uses base64url (- and _). atob expects + and /
  let b64 = b64url.replace(/-/g, '+').replace(/_/g, '/');
  // add padding if needed
  const pad = b64.length % 4;
  if (pad === 2) b64 += '==';
  else if (pad === 3) b64 += '=';
  else if (pad !== 0) b64 += '===';
  return b64;
}

function parseJwt(token) {
  try {
    const parts = token.split('.');
    if (parts.length < 2) return null;
    const payloadB64Url = parts[1];
    const json = atob(toBase64(payloadB64Url));
    return JSON.parse(json);
  } catch {
    return null;
  }
}

function normalizeToken(maybeToken) {
  // Handle APIs that return { token: "..." } or just "..."
  if (!maybeToken) return null;
  if (typeof maybeToken === 'string') return maybeToken;
  if (typeof maybeToken === 'object' && typeof maybeToken.token === 'string') {
    return maybeToken.token;
  }
  return null;
}

// --- public API ---
export async function signUp(userData) {
  const raw = await usersAPI.signUp(userData);
  const token = normalizeToken(raw);
  if (!token) throw new Error('Sign up did not return a valid token');
  localStorage.setItem('token', token);
  return getUser();
}

export async function login(credentials) {
  const raw = await usersAPI.login(credentials);
  const token = normalizeToken(raw);
  if (!token) throw new Error('Login did not return a valid token');
  localStorage.setItem('token', token);
  return getUser();
}

export function logOut() {
  localStorage.removeItem('token');
}

export function getToken() {
  const token = localStorage.getItem('token');
  if (!token) return null;

  const payload = parseJwt(token);
  if (!payload || typeof payload.exp !== 'number') {
    // Bad token: clear and fail quietly
    localStorage.removeItem('token');
    return null;
  }

  // exp is in seconds
  if (payload.exp < Date.now() / 1000) {
    localStorage.removeItem('token');
    return null;
  }
  return token;
}

export function getUser() {
  const token = getToken();
  if (!token) return null;
  const payload = parseJwt(token);
  return payload?.user ?? null;
}

export function checkToken() {
  return usersAPI.checkToken().then(dateStr => new Date(dateStr));
}



// at bottom with other exports - adding 10.21.25
export function listAllUsers() {
  return usersAPI.listAllUsers(); // returns the array of users (JSON)
}